import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import {
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	const [getServiceShowOffenceDetailReviewResult, setServiceShowOffenceDetailReviewResult] = useState(false);
	const [getShowVerdictIssuedReviewResult, setShowVerdictIssuedReviewResult] = useState(false);
	const [getShow, setShow] = useState(false);
	const [getShow1, setShow1] = useState(false);

	useEffect(() => {
		var inputValue = {
			session: GetLocal('EmployeeSession'),
			requestNumber: GetLocal('RequestNumber')
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowOffenceReview", inputValue, ShowOffenceReviewSuccess);
	}, []);

	const ShowOffenceReviewSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
	}

	const ShowOffenceDetailReview = (id) => {
		var inputValue = {
			session: GetLocal('EmployeeSession'),
			requestNumber: GetLocal('RequestNumber'),
			determinedOffenceSerialNumber: id
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowOffenceDetailReview", inputValue, ShowOffenceDetailReviewSuccess);
	}

	const ShowOffenceDetailReviewSuccess = (ServiceResult) => {
		setShow(true);
		setShow1(false);
		setServiceShowOffenceDetailReviewResult(ServiceResult);
	}

	const ShowVerdictIssuedReview = (id) => {
		var inputValue = {
			session: GetLocal('EmployeeSession'),
			requestNumber: GetLocal('RequestNumber'),
			sentCommitteeNumber: id
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowVerdictIssuedReview", inputValue, ShowVerdictIssuedReviewSuccess);
	}

	const ShowVerdictIssuedReviewSuccess = (ServiceResult) => {
		setShow1(true);
		setShowVerdictIssuedReviewResult(ServiceResult);
	}

	const DeterminedOffenceSerialNumberAction = (row) => {
		ShowOffenceDetailReview(row.DeterminedOffenceSerialNumber)
	}

	const ShowVerdictIssuedReviewAction = (row) => {
		ShowVerdictIssuedReview(row.SentCommitteeNumber)
	}

	function formatNumberWithComma(value) {
		if (value === null || value === undefined || value === "") return "";

		return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	return (
		<div>
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')} />
			<ShowFilesReviewAbstractList />
			{getServiceResult ? <div>
				<GridControl
					data={Object.keys(getServiceResult).length > 0 && getServiceResult.OffenceInfo}
					customHeaders={{
						"InspectNumber": "شماره ترتیب بازدید",
						"DeterminedOffenceDate": "تاریخ تعیین خلاف",
						"PreventionNumber": "شماره فرم جلوگیری",
						"PreventionDate": "تاریخ فرم جلوگیری",
						"NoticeOffenceNumber": "شماره اخطاریه رفع خلاف",
						"NoticeOffenceDate": "تاریخ اخطاریه رفع خلاف",
						"OffenceStatus": "وضعیت",
						"ViewAction": "جزییات"
					}}
					ViewAction={DeterminedOffenceSerialNumberAction}
				/>

				<hr />

				{getShow &&
					<div>
						<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
							<tbody>
								<tr>
									<td><b class="b1">دارای خلاف پارکینگ:</b> {getServiceShowOffenceDetailReviewResult.IsOffenceParking ? 'دارد' : 'ندارد'}</td>
									<td><b class="b1">کسری:</b> {getServiceShowOffenceDetailReviewResult.UnitLack}</td>
									<td><b class="b1">مورد نیاز:</b> {getServiceShowOffenceDetailReviewResult.RequiredArea}</td>
								</tr>
							</tbody>
						</table>

						<hr />

						<GridControl
							data={Object.keys(getServiceShowOffenceDetailReviewResult).length > 0 && getServiceShowOffenceDetailReviewResult.DeterminedOffenceInfo}
							customHeaders={{
								"OffenceTypeCode": "نوع خلاف",
								"PrimaryUsedTitle": "نوع استفاده",
								"UnitLack": "واحد",
								"RequiredArea": "مساحت",
								"OffenceTypeDescription": "شرح نوع خلاف",
								"Description": "توضیحات"
							}}
						/>

						<hr />

						<GridControl
							data={Object.keys(getServiceShowOffenceDetailReviewResult).length > 0 && getServiceShowOffenceDetailReviewResult.CommitteeInfo}
							customHeaders={{
								"SentCommitteeNumber": "شماره نامه ارسال به کمیسیون",
								"SentCommitteeDate": "تاریخ ارسال یه کمیسیون",
								"CommitteeTypeTitle": "نوع کمیسیون",
								"RegisterDate": "تاریخ ثبت رای",
								"NoticeCommitteeNumber": "شماره اخطاریه کمیسیون",
								"NoticeCommitteeDate": "تاریخ اختیاریه کمیسیون",
								"VoteStatusTitle": "وضعیت کلی",
								"ViewAction": "جزییات"
							}}
							ViewAction={ShowVerdictIssuedReviewAction}
						/>
						<hr />
						{getShow1 &&
							<div>

								<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
									<tbody>
										<tr>
											<td><b class="b1">ادعای شهرداری:</b> {getShowVerdictIssuedReviewResult.ClaimMunicipalityDescription}</td>
											<td width="700"><b class="b1">توضیح ثبت:</b> {getShowVerdictIssuedReviewResult.VoteRegistrationDescription}</td>
											<td><b class="b1">نوع رای:</b> {getShowVerdictIssuedReviewResult.VoteTypeDescription}</td>
										</tr>
										<tr>
											<td><b class="b1">شماره رای:</b> {getShowVerdictIssuedReviewResult.VoteNumber}</td>
											<td><b class="b1">تاریخ رای:</b> {getShowVerdictIssuedReviewResult.VoteDate}</td>
											<td><b class="b1">شماره نامه:</b> {getShowVerdictIssuedReviewResult.LetterNumber}</td>
										</tr>
										<tr>
											<td><b class="b1">تاریخ نامه:</b> {getShowVerdictIssuedReviewResult.LetterDate}</td>
											<td><b class="b1">شماره کمیسیون:</b> {getShowVerdictIssuedReviewResult.CommitteeNumber}</td>
											<td><b class="b1">شماره پرونده کمیسیون:</b> {getShowVerdictIssuedReviewResult.CommitteeFileNumber}</td>
										</tr>
										<tr>
											<td><b class="b1">مهلت اجرای رای:</b> {getShowVerdictIssuedReviewResult.VoteDeadline}</td>
											<td><b class="b1">مهلت اجرای رای:</b> {getShowVerdictIssuedReviewResult.VoteProtestDeadline}</td>
										</tr>
									</tbody>
								</table>

								<hr />

								<GridControl
									data={Object.keys(getShowVerdictIssuedReviewResult).length > 0 && getShowVerdictIssuedReviewResult.VerdictIssuedInfo}
									customHeaders={{
										"OffenceTypeCode": "نوع خلاف",
										"PrimaryUsedTitle": "نوع استفاده کننده",
										"VoteTypeTitle": "رای",
										"Penalty": "مبلغ",
										"BasePrice": "قیمت پایه",
										"UnitLack": "واحد-کسری",
										"RequiredArea": "مساحت-موردنیاز",
										"ChargesCoefficient": "ضریب",
										"ProtestStatus": "مورد اعتراض مالک",
										"ExecutionStatus": "وضعیت",
										"OffenceTypeDescription": "شرح نوع خلاف",
										"OffenceDescription": "توضیحات خلاف"
									}}
									customRenderCell={{
										Penalty: (row) => (
											<div dir="ltr" style={{ textAlign: "center" }}>
												{formatNumberWithComma(row.Penalty)}
											</div>
										),
										BasePrice: (row) => (
											<div dir="ltr" style={{ textAlign: "center" }}>
												{formatNumberWithComma(row.BasePrice)}
											</div>
										)
									}}
								/>

								<hr />

								<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
									<tbody>
										<tr>
											<td><b class="b1">شماره ابلاغیه:</b> {getShowVerdictIssuedReviewResult.NoticeNumber}</td>
											<td><b class="b1">نام ابلاغ کننده:</b> {getShowVerdictIssuedReviewResult.CommunicantName}</td>
											<td><b class="b1">نام ابلاغ گیرنده:</b> {getShowVerdictIssuedReviewResult.RecipientName}</td>
										</tr>
										<tr>
											<td><b class="b1">تاریخ ابلاغیه:</b> {getShowVerdictIssuedReviewResult.NoticeIssueDate}</td>
											<td><b class="b1">جمع مبلغ:</b> {formatNumberWithComma(getShowVerdictIssuedReviewResult.TotalPenalty)}</td>
											<td><b class="b1">تاریخ ثبت ابلاغیه:</b> {getShowVerdictIssuedReviewResult.NoticeRegisterDate}</td>
										</tr>
									</tbody>
								</table>

								<hr />

								<GridControl
									data={Object.keys(getShowVerdictIssuedReviewResult).length > 0 && getShowVerdictIssuedReviewResult.NotificationInfo}
									customHeaders={{
										"WarningNumber": "شماره اخطاریه",
										"WarninglssueDate": "تاریخ صدور",
										"WarningPeriod": "مهلت اخطار",
										"WarningRegisterDate": "تاریخ ثبت",
										"CommunicantName": "نام اخطار کننده",
										"RecipientName": "نام اخطار گیرنده"
									}}
								/>
								<hr />

								<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
									<tbody>
										<tr>
											<td><b class="b1">توضیح اعتراض شهرداری:</b> {getShowVerdictIssuedReviewResult.MunicipalityProtestDescription}</td>
											<td><b class="b1">تاریخ اعتراض:</b>{getShowVerdictIssuedReviewResult.MunicipalityProtestDate}</td>
										</tr>
										<tr>
											<td><b class="b1">توضیح اعتراض مالک:</b> {getShowVerdictIssuedReviewResult.OwnerProtestDescription}</td>
											<td><b class="b1">تاریخ اعتراض:</b>{getShowVerdictIssuedReviewResult.OwnerProtestDate}</td>
										</tr>
										<tr>
											<td><b class="b1">نام اعتراض کننده (مالک):</b> {getShowVerdictIssuedReviewResult.ProtesterName}</td>
											<td><b class="b1">شماره وکالت:</b>{getShowVerdictIssuedReviewResult.ProtesterProxyNumber}</td>
										</tr>
										<tr>
											<td><b class="b1">نشانی اعتراض کننده:</b> {getShowVerdictIssuedReviewResult.ProtesterAddress}</td>
											<td><b class="b1">شماره اعتراض:</b> {getShowVerdictIssuedReviewResult.OwnerProtestNumber}</td>
										</tr>
										<tr>
											<td><b class="b1">تارریخ اجرا / عدم اجرای رای:</b> {getShowVerdictIssuedReviewResult.VoteImplementationDate}</td>
											<td><b class="b1">نام مامور بازدید:</b> {getShowVerdictIssuedReviewResult.VisitorName}</td>
										</tr>
										<tr>
											<td colspan="2"><b class="b1">توضیح اجرا / عدم اجرا:</b> {getShowVerdictIssuedReviewResult.VoteImplementationDescription}</td>
										</tr>
									</tbody>
								</table>
							</div>
						}
					</div>
				}
			</div>
				:
				<div className="alert alert-danger text-center">موردی یافت نشد.</div>
			}
		</div>
	);
}
